import type { ChatbotTrainingExamplesPageSize } from '../../types/userConfig';

export const TRAINING_EXAMPLES_SEARCH_DEBOUNCE_MS = 500;
export const TRAINING_EXAMPLES_SEARCH_MIN_LENGTH = 3;

export type TrainingExamplesSearchState = {
  debouncedQuery: string;
};

export type ChatbotTrainingExamplesListOptions = {
  limit: number;
  offset: number;
  search?: string;
  sort: 'modified';
};

export function parseTrainingExamplesPageFromSearchParams(
  searchParams: URLSearchParams,
): number {
  const rawPage = Number(searchParams.get('page') ?? '1');
  if (!Number.isFinite(rawPage) || rawPage < 1) {
    return 1;
  }
  return Math.floor(rawPage);
}

export function buildTrainingExamplesSearchParams({
  page,
  searchInput,
}: {
  page: number;
  searchInput: string;
}): URLSearchParams {
  const params = new URLSearchParams();

  const trimmedSearch = searchInput.trim();
  if (trimmedSearch !== '') {
    params.set('search', trimmedSearch);
  }

  if (page > 1) {
    params.set('page', String(page));
  }

  return params;
}

export function buildTrainingExamplesListOptions(
  search: TrainingExamplesSearchState,
  page: number,
  pageSize: ChatbotTrainingExamplesPageSize,
): ChatbotTrainingExamplesListOptions {
  const options: ChatbotTrainingExamplesListOptions = {
    limit: pageSize,
    offset: (page - 1) * pageSize,
    sort: 'modified',
  };

  if (search.debouncedQuery.length >= TRAINING_EXAMPLES_SEARCH_MIN_LENGTH) {
    options.search = search.debouncedQuery;
  }

  return options;
}
